import { render, staticRenderFns } from "./weekday.vue?vue&type=template&id=6c22dadb&"
import script from "./weekday.vue?vue&type=script&lang=js&"
export * from "./weekday.vue?vue&type=script&lang=js&"
import style0 from "./weekday.vue?vue&type=style&index=0&id=6c22dadb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports